// store.js

import { configureStore } from "@reduxjs/toolkit";
import BuildingSlice from "./Reducer/BuildingSlice";
import DashboardSlice from "./Reducer/DashboardSlice";
import FinancialYearEndSlice from "./Reducer/FinancialYearEndSlice";
import GlobalSlice from "./Reducer/GlobalSlice";
import InsuranceRenewalSlice from "./Reducer/InsuranceRenewalSlice";
import LayoutSlice from "./Reducer/LayoutSlice";
import LoaderSlice from "./Reducer/LoaderSlice";
import MeetingRegisterSlice from "./Reducer/MeetingRegisterSlice";
import RolesSlice from "./Reducer/RolesSlice";
import TermDepositSlice from "./Reducer/TermDepositSlice";
import UsersSlice from "./Reducer/UsersSlice";
import SideMenuSlice from "./Reducer/SideMenuSlice";
import WebMenuSlice from "./Reducer/WebMenuSlice";

const Store = configureStore({
  reducer: {
    layout: LayoutSlice,
    global: GlobalSlice,
    sideMenu: SideMenuSlice,
    webMenu: WebMenuSlice,
    dashboard: DashboardSlice,
    financialYearEnd: FinancialYearEndSlice,
    insuranceRenewal: InsuranceRenewalSlice,
    termDeposit: TermDepositSlice,
    roles: RolesSlice,
    users: UsersSlice,
    building: BuildingSlice,
    meetingRegister: MeetingRegisterSlice,
    loader: LoaderSlice,
  },
});

export default Store;
